import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-500 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading font-black text-lg text-background-50">生活中的玛丽</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">
              专注电影与电视剧资讯、剧情介绍及影评分析，帮助每一位影视爱好者快速了解最新影视作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">内容导航</h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li><Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/movie" className="hover:text-accent-400 transition-colors cursor-pointer">电影分类</Link></li>
              <li><Link to="/category/tv" className="hover:text-accent-400 transition-colors cursor-pointer">电视剧分类</Link></li>
              <li><Link to="/special" className="hover:text-accent-400 transition-colors cursor-pointer">影评专题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">关于我们</h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">网站介绍</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 transition-colors cursor-pointer">站内搜索</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">使用说明</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">版权声明</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@marylife.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                <span>内容合作与反馈</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                <span>工作日 9:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-primary-400/40 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© {year} 生活中的玛丽 · 保留所有权利</p>
          <p>本站影视资讯为演示内容，真实动态内容待后端接口接入</p>
        </div>
      </div>
    </footer>
  );
}